import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateWorkerPermDesiredDetailsRequest extends BaseUpdateRequest {
    desiredAnnualSalary = 0;
}